<template>
    <div class="export-project-quick">
        <export-steps :steps="steps" :current-step="stepIndex"></export-steps>
        <div class="step-container">
            <div class="popper-desc" v-if="stepIndex === 0">
                {{$t("export_project.message_quick_connnect")}}
            </div>
            <div class="popper-desc" v-if="stepIndex === 1 && exportStatus === 0">
                {{$t("export_project.title_connected_robots")}}
            </div>
            <code-inputer v-show="stepIndex === 0" @change="onVerCodeChange" @confirm="startConnect"></code-inputer>
            <device-list 
            v-if="stepIndex === 1 && getDeviceData && exportStatus === 0" 
            target="quick" 
            :data="getDeviceData" 
            :total-size="totalProjectSize" 
            @select-device="onSelectDevice"
            ></device-list>
            <send-project-status 
            style="margin-top:25px;"
            v-if="stepIndex !== 0 &&  exportStatus !== 0"
            :status-code="exportStatus"
            :progress="sendProgress"
            :status-config="sendStatusConfig"
            ></send-project-status>
        </div>
        <div class="footer">
            <template v-if="stepIndex === 0"> 
                <p class="vercode-tip"><span @click="showVercodeTip">{{$t("code-lab/component/connection/quick/quick-cnnection.vue_12")}}</span></p>
                <div>
                    <span class="export-pop-button gray line" 
                    v-if="currentVersion === 'teacher'" 
                    @click="$emit('change-target', 'rms')"
                    >{{$t("export_project.switch_rms")}}</span>
                    <button v-if="stepIndex === 0" class="export-pop-button blue" :class="{disabled: !canConnect}" @click="startConnect">{{$t("export_project.start_connect")}}</button>
                </div>
            </template>
            <template v-else-if="stepIndex === 1 && exportStatus === 0">
                <div class="project-size">
                    {{$t("export.project_size",{size: projectInfos[0] ? projectInfos[0].formatedSize : "..."})}}
                </div>
                <div>
                    <span class="export-pop-button gray line" 
                    v-if="connected" 
                    @click="closeQuick"
                    >{{$t("export_project.exchange_robot")}}</span>
                    <button class="export-pop-button blue" :class="{disabled: !hasProjectInfo || targetDevices.length === 0}" @click="startExport">{{$t("export_project.start_export")}}</button>
                </div>
            </template>
            <template v-else-if="stepIndex === 1 && exportStatus === 1">
                <span></span>
                <button class="export-pop-button gray disabled">{{$t("button.cancel")}}</button>
            </template>
            <template v-else-if="stepIndex === 2">
                <span class="find-project-tip">
                    <span v-if="exportStatus === 2">
                        <el-tooltip  popper-class="export-project-tooltip" placement="top-start">
                            <div class="toolti-content" slot="content">
                                {{$t('export_project.find_file_tip')}}
                            </div>
                            <span class="el-icon-warning-outline warn-trigger"></span>
                        </el-tooltip>
                        <span style="vertical-align:middle;">
                            {{$t("export_project.cant_find_file")}}
                        </span>
                    </span>
                </span>
                <button  v-if="exportStatus === 2" class="export-pop-button gray" @click="$emit('close')">{{$t("export_project.complate_export")}}</button>
                <div v-if="exportStatus === 3">
                    <button class="export-pop-button gray" @click="$emit('close')">{{$t("button.cancel")}}</button>
                    <button class="export-pop-button blue" @click="startExport">{{$t("export_project.resend")}}</button>
                </div>
            </template>
        </div>
        <connect-description
            class="connect-status"
            ref="connect-description"
            v-if="showVercodePopper"
        />
    </div>
</template>
<script>
import { LoginQuick } from '@/code-lab/component/connection/quick/login.js'
import exportSteps from "./export-steps.vue";
import codeInputer from "@/code-lab/component/file-management/export-excute/code-inputer.vue";
import connectDescription from "@/code-lab/component/connection/description.vue";
import quickConnectMix from "@/code-lab/component/connection/quick/quick-connect-mix.js";
import initSocketCicleMix from "@/code-lab/component/mixins/init-socket-cicle-mix.js";
import mixFileManagement from "@/code-lab/component/file-management/mixins/mix-file-request-manage.js"; 
import sendProjectStatus from "./send-project-status.vue";
import deviceList from "./device-list.vue";
import config from "@/service/config.js";
import { mapState, mapActions, mapGetters } from 'vuex';
import {closeQuick, closeRms, closeWhite} from "./close-connection";
const baseUrl$ = process.env.BASE_URL;
export default {
    name: "export-project-quick",
    mixins: [quickConnectMix, initSocketCicleMix, mixFileManagement],
    components: {
        exportSteps,
        codeInputer,
        connectDescription,
        deviceList,
        sendProjectStatus
    },
    props: {
        data: Array
    },
    data(){
        return {
            steps: [
                {
                    label: this.$t("export_project.step_1"),
                },
                {
                    label: this.$t("export_project.step_2"),
                },
                {
                    label: this.$t("export_project.step_3")
                }
            ],
            stepIndex: 0,
            canConnect: false,
            showVercodePopper: true,
            exportStatus: 0,//0-未派發，1-派發中，2-派發完成，3-派發失敗
            projectInfos: [],
            targetDevices: [],
            sendProgress: 0,
            sendStatusConfig: {
                1: {
                    title: this.$t("export_project.title_1"),
                    message: percent => {
                        return this.$t("export_project.message_1", {percent})
                    },
                    image: baseUrl$ + "static/images/send_status_1.png"
                },
                2: {
                    title: this.$t("export_project.title_2"),
                    message: this.$t("export_project.message_2"),
                    image: baseUrl$ + "static/images/send_status_2.png"
                },
                3: {
                    title: this.$t("export_project.title_3"),
                    message: this.$t("export_project.message_3"),
                    image: baseUrl$ + "static/images/send_status_3.png"
                }
            }
        }
    },
    computed: {
        ...mapState('user', [
            'token'
        ]),
        ...mapState([
            "currentVersion",
            "connectGolbalState",
        ]),
        ...mapState("quickConnection", [ "socketCode", "robotInfo"]),
        ...mapGetters("quickConnection", ["getDeviceData"]),
        connected(){
            return [2,3].includes(this.socketCode)
        },
        hasProjectInfo(){
            return this.projectInfos.length === this.data.length && this.projectInfos.length > 0;
        },
        totalProjectSize(){
            let size = 0;
            this.projectInfos.forEach(item => size += item.size);
            return size;
        }
    },
    watch: {
        socketCode(code){
            console.log("socket code change:", )
            if([2,3].includes(code)){
                this.stepIndex = 1;
            } else {
                //断线
                this.sendProgress = 0;
                this.exportStatus = 0;
                this.stepIndex = 0;
            }
        },
        connectGolbalState(value, oldValue){
            if([1, 3].includes( oldValue )){
                return;
            }
            console.log("connect global state change:", value);
        }
    },
    created(){
        this.projectInfos = [];
        this.data.forEach(project => {
            this.getProjectUrl(project.projectId, res => {
                this.projectInfos.push(Object.assign(res, {name: project.name}));
            });
        })
    },
    mounted(){
        this.$nextTick(() => {
            this.checkConnection();
        })
    },
    methods: {
        ...mapActions("quickConnection", ["getRobotInfo"]),
        closeQuick, 
        closeRms,
        closeWhite,
        checkConnection(){
            console.log("checkConnection", this.connectGolbalState)
            if(this.connectGolbalState === 2){
                this.stepIndex = 1;
            } else {
                //沒有連線機器人
                this.stepIndex = 0;
            }
        },
        async startConnect(){
            if(!this.canConnect){
                return;
            }
            if([1, 3].includes( this.connectGolbalState )){
                console.log("关闭rms连线")
                await this.closeRms();
                await this.closeWhite()
            }
            if(!this.b$.quick){
                await this.initQuickSocket();
            }
            await this.quickConnect(this.verCode);
        },
        async quickConnect({randomCode, serialNumber}) {
            if (!randomCode || !serialNumber) return console.error("not correct formatt of data!", randomCode)
            const { webSocketProtocol, quickConnectionWebsocketUrl } = config
            const url = webSocketProtocol + quickConnectionWebsocketUrl + "?token=" + this.token
            await this.b$.start("quick", url, "ws.open", () => {
                this.b$.assignment("quick", {
                    store: {
                        token: this.token,
                        serialNumber: "710786",
                        clientId: "2-serialNumber",
                        ver: "v1"
                    }
                });
                this.b$.assignment("quick", { randomCode, serialNumber }, "store");
                new LoginQuick(this.b$.quick.store).loginIn()
            })
        },
        onVerCodeChange(value){
            this.canConnect = !!value;
            this.verCode = value;
        },
        showVercodeTip () {
            if (!this.showVercodePopper) return false;
            this.$refs["connect-description"].handleEvent(true);
        },
        getProjectUrl(projectId, callback = () => {}){
            this.export_execute_file$(res => {
                if(!["task_creating", "task_created", "task_finished"].includes(res.data.state)){
                    this.getProjectInfoError = true;
                } else if(res.data.state === "task_finished"){
                    const {projectId, url, size} = res.data;
                    callback({projectId, url, size, formatedSize: this.util$.diskSize$(size, "MB")})
                }
            }, {projectId})
        },
        onSelectDevice(devices){
            this.targetDevices = devices;
        },
        startExport(){
            if(!this.hasProjectInfo || this.targetDevices.length === 0){
                return;
            }
            const {url, name: destinationName, size} = this.projectInfos[0];
            const to = this.targetDevices[0];
            this.exportStatus = 1;
            this.stepIndex = 1;
            this.sendProgress = 0;
            const data = {
                cmd: "set_code_install",
                data: {
                    destinationName,
                    url,
                    size,
                    from: "server",
                    to
                }
            };
            this.b$.send("quick", data, res => {
                console.log("set_code_install:", res)
                if(res.cmd === "code_install_progress"){
                    this.sendProgress = res.data.progress;
                }
                if (res.cmd === "code_install_response" && res.data) {
                    if (typeof res.data.result !== 'boolean'){
                        this.sendProgress = 3;
                    } else if (res.data.result) {
                        this.exportStatus = 2;
                    } else if (!res.data.result) {
                        this.sendProgress = 3;
                    }
                    this.stepIndex = 2;
                }
            })
        }
    }
}
</script>
<style lang="scss">
.export-project-quick{
    .popper-desc{
        font-size: 16px;
        color: #ffffff;
        padding: 18px 0;
    }
    .popper-title{
        font-size: 14px;
        color: #ffffff;
    }
    .step-container{
        width: 100%;
    }
    .footer{
        width: 100%;
        margin-top: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .vercode-tip{
            span{
                text-decoration: underline;
                font-size: 12px;
                color: #a8a8ac;
                &:hover{
                    color: #0ed3ff;
                }
            }
        }
        .project-size{
            display: inline-block;
            padding: 4px 12px;
            border-radius: 4px;
            background-color: rgba(168, 168, 172, 0.2);
            font-size: 12px;
            color: #ffffff;
        }
        .find-project-tip{
            color: #c8c8c8;
            .warn-trigger{
                display: inline-block;
                font-size: 20px;
                width: 40px;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                text-align: center;
                vertical-align:middle;
                &:hover{
                    background-color: rgba(255, 255, 255, 0.1);
                }
            }
        }
    }
}
</style>